import { c as _c } from "react/compiler-runtime";
interface PainMedicineIconProps {
  size?: number;
  className?: string;
}
const PainMedicineIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <g clipPath="url(#clip0_350_9119)"><path d="M13.6955 6.77639L21.2239 14.3048M18.963 12.0439L23.2283 7.77858M15.9564 9.03733L20.2217 4.77202M24.3187 8.86094L19.1394 3.68164M7.97902 20.0213L3.68164 24.3187M7.74651 15.3792L9.08543 16.7181M10.1838 12.9338L11.5227 14.2727M12.6292 10.4965L13.9681 11.8354M15.0184 8.09928L19.893 12.9739L12.1321 20.7348C11.186 21.6809 9.64666 21.6809 8.69257 20.7348L7.24943 19.2917C6.30336 18.3456 6.30336 16.8063 7.24943 15.8522L15.0184 8.09928Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <defs><clipPath id="clip0_350_9119"><rect width="22" height="22" fill="white" transform="translate(3 3)" /></clipPath></defs>;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t5) {
    t8 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}</svg>;
    $[4] = t3;
    $[5] = t5;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default PainMedicineIcon;